import { SatisfactionResult } from './models';

export function calculateSatisfaction(rate?: number, ratesNumber?: number): SatisfactionResult {
    const hasRate = Number.isFinite(rate);
    const hasRatesNumber = Number.isFinite(ratesNumber);

    if (!hasRate || !hasRatesNumber || rate === undefined) {
        return {
            percent: 0,
            performance: 'بدون نظر',
            className: 'bg-gray-50 text-gray-500',
            textClassName: 'text-gray-500',
            fillClassName: 'text-gray-300'
        };
    }

    const percent = Math.round((rate / 5) * 100);

    if (percent >= 90) {
        return {
            percent,
            performance: 'عالی',
            className: 'bg-rating-excellent/10 text-rating-excellent-foreground',
            textClassName: 'text-rating-excellent-foreground',
            fillClassName: 'text-rating-excellent'
        };
    }
    if (percent >= 75) {
        return {
            percent,
            performance: 'خیلی خوب',
            className: 'bg-rating-veryGood/10 text-rating-veryGood-foreground',
            textClassName: 'text-rating-veryGood-foreground',
            fillClassName: 'text-rating-veryGood'
        };
    }
    if (percent >= 60) {
        return {
            percent,
            performance: 'خوب',
            className: 'bg-rating-good/10 text-rating-good-foreground',
            textClassName: 'text-rating-good-foreground',
            fillClassName: 'text-rating-good'
        };
    }
    if (percent >= 40) {
        return {
            percent,
            performance: 'متوسط',
            className: 'bg-rating-average/10 text-rating-average-foreground',
            textClassName: 'text-rating-average-foreground',
            fillClassName: 'text-rating-average'
        };
    }
    return {
        percent,
        performance: 'ضعیف',
        className: 'bg-rating-poor/10 text-rating-poor-foreground',
        textClassName: 'text-rating-poor-foreground',
        fillClassName: 'text-rating-poor'
    };
}
